import { atom } from "jotai";
import {
    AI_GENERATION_COMPLETION_STATUS,
    AI_GENERATION_PROGRESS,
} from "../../../../constants";

type ExportInterview = Record<
    string,
    {
        exportInterviewInProgress: string;
        exportInterviewInCompletionStatus: string;
    }
>; 

export const INITIAL_EXPORT_INTERVIEW_STATE: ExportInterview = {};

export const exportInterviewAtom = atom(INITIAL_EXPORT_INTERVIEW_STATE);

export const setExportInterviewProgress = (setState, teamID, progressStatus) => {
    setState((state: ExportInterview) => {
        const newState = { ...state };

        if (newState[teamID]) {
            newState[teamID].exportInterviewInProgress = progressStatus;

            if (progressStatus === AI_GENERATION_PROGRESS.IN_PROGRESS) {
                newState[teamID].exportInterviewInCompletionStatus =
                    AI_GENERATION_COMPLETION_STATUS.NO_STATUS;
            }
        } else {
            newState[teamID] = {
                exportInterviewInProgress: progressStatus,
                exportInterviewInCompletionStatus:
                    AI_GENERATION_COMPLETION_STATUS.NO_STATUS,
            };
        }

        return newState;
    });
};

export const setExportInterviewCompletionStatus = (setState, teamID, status) => {
    setState((state: ExportInterview) => {
        const newState = { ...state };

        if (newState[teamID]) {
            newState[teamID].exportInterviewInCompletionStatus = status;

            if (status !== AI_GENERATION_COMPLETION_STATUS.NO_STATUS) {
                newState[teamID].exportInterviewInProgress =
                    AI_GENERATION_PROGRESS.DONE;
            } else {
                newState[teamID].exportInterviewInProgress =
                    AI_GENERATION_PROGRESS.NOT_STARTED;
            }
        } else {
            newState[teamID] = {
                exportInterviewInCompletionStatus: status,
                exportInterviewInProgress:
                    status !== AI_GENERATION_COMPLETION_STATUS.NO_STATUS
                        ? AI_GENERATION_PROGRESS.DONE
                        : AI_GENERATION_PROGRESS.NOT_STARTED,
            };
        }

        return newState;
    });
};
